import { createSelector } from 'reselect';

const chatSelector = state => state.chat;

export const getIsChatFetching = createSelector(
  [chatSelector],
  result => result.isFetchingCount > 0,
);

export const getIsChatTyping = createSelector(
  [chatSelector],
  result => (result ? result.isTyping : undefined),
);

export const getTypingMessageId = createSelector(
  [chatSelector],
  result => (result ? result.typingMessageId : undefined),
);

export const getConvertedText = createSelector(
  [chatSelector],
  result => (result ? result.convertedText : undefined),
);

export const getLastMessageId = createSelector(
  [chatSelector],
  (result) => {
    const lastMessage = result.messages ? result.messages[result.messages.length - 1] : null;
    return lastMessage && lastMessage.id;
  },
);

export const getChatMessages = createSelector(
  [chatSelector],
  (result) => {
    // Якщо result.messages є масивом, повертаємо його копію у зворотному порядку
    if (Array.isArray(result.messages)) {
      return [...result.messages].reverse();
    }
    // Якщо result.messages не масив, повертаємо пустий масив або обробляємо іншим чином
    return [];
  },
);

export const getReportChannel = reportId => createSelector(
  [chatSelector],
  chat => chat.channels.find(channel => channel.report_id === reportId),
);
export const getChatPayloadData = reportId => createSelector(
  [getReportChannel(reportId)],
  (channel) => {
    if (!channel || !channel.data || !channel.data.length) {
      return null;
    }
    return channel.data.find(data => data.report_id === reportId);
  },
);
export const getTokensInfo = createSelector(
  [chatSelector],
  chat => chat.tokens,
);

export const getIsChatWaiting = createSelector(
  [chatSelector],
  result => (result ? result.isWaiting : undefined),
);
